import { Component, createRef } from "react";
import { connect } from "react-redux";
import {
  set_datapage,
  getMapStateDefault,
} from "@ora/recursos/src/redux/actions/DataPageAction";
import { Templates } from "@ora/recursos";
import {
  checkDataDirectorio,
  // seDataDirectorio,
  seDatatDocumentos,
} from "@ora/recursos/src/redux/actions/DirectoriosActions";
import "@loadingio/loading.css/dist/loading.css";

import { Card, Section } from "react-bulma-components";
import axios from "axios";
import { baseUrl, localUrl } from "@ora/recursos/src/helpers/Url";
import MediaColumnFicha from "layouts/mainsection/components/MediaColumnFicha";

class CientificosShow extends Component {
  state = {
    data: null,
  };
  constructor(props) {
    super(props);
    console.log("constructor", this.props);
    this.props.set_datapage({
      titulo: "Ficha del Cientifico o Academico",
      isbackend: true,
      breadcrumb: [
        { name: "Intranet", url: "#" },
        { name: "Config", url: "#" },
        { name: "Ficha del Cientifico o Academico", url: "#", active: true },
      ],
    });
    this.spinnerLoad = createRef();

    axios
      .get(
        baseUrl(
          "cites/cientifico/" + this.props.match.params.idrecurso + "?m=format"
        )
      )
      .then((res) => {
        if (res.data.success) {
          this.setState({
            data: res.data.data,
          });
        }
        console.log(res.data.data);
        this.spinnerLoad.current.classList.add("is-hidden");
      });
  }
  FnDetallesFicha = () => {
    let t = [];

    return this.state.data || [];
  };
  OnClick_regresar = () => {
    console.log(this.props.history);
    this.props.history.goBack();
  };
  render() {
    return (
      <Templates.Default.BasePageRoute2
        localUrl={localUrl}
        dataPage={this.props.DataPage}
      >
      <div className="is-main-section">
        <Card>
          <Card.Header>
            <Card.Header.Title>
              <span className="icon">
                <i className="fas fa-file-invoice"></i>
              </span>
              Datos
            </Card.Header.Title>
          </Card.Header>
          <Card.Content>
            <div
              ref={this.spinnerLoad}
              className="ld ld-spinner  ld-spin"
            ></div>
            <div className="media-list">
              {this.FnDetallesFicha()
                .sort((a, b) => {
                  if (a.order > b.order) {
                    return 1;
                  }
                  if (a.order < b.order) {
                    return -1;
                  }
                  // a must be equal to b
                  return 0;
                })
                .map(
                  (item, index) =>
                    item.show && (
                      <MediaColumnFicha
                        key={index}
                        columna={item.name}
                        detalle={item.value}
                      ></MediaColumnFicha>
                    )
                )}
            </div>
            <hr />
            <div className="field is-horizontal">
              <div className="field-label is-normal" />
              <div className="field-body">
                <div className="field">
                  <div className="field">
                    <div className="field-body">
                      <div className="field has-text-right">
                        <div className="control">
                          <button
                            onClick={this.OnClick_regresar}
                            type="button"
                            className="button is-danger"
                          >
                            <span>Regresar</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card.Content>
        </Card>
      </div>
      </Templates.Default.BasePageRoute2>
    );
  }
}
export default connect(getMapStateDefault(), {
  set_datapage,
  seDatatDocumentos,
  checkDataDirectorio,
})(CientificosShow);


